module.exports = __webpack_public_path__ + "img/search.9e5880bd.svg";